import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { StateTag, YesNoTag } from "@msuite/ui/tag";
import { createdAtFormatter, updatedAtFormatter } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { AcknowledgementDefinitionsListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<AcknowledgementDefinitionsListItem>();

export function createColumns(isProjectContext: boolean) {
	return [
		columnHelper.accessor("text", {
			id: "text",
			header: localized("general.text"),
			cell: (cell) => cell.getValue(),
		}),
		columnHelper.accessor("state", {
			id: "state",
			header: localized("general.state"),
			cell: (cell) => <StateTag state={cell.getValue()} />,
		}),
		columnHelper.accessor("default", {
			id: "default",
			header: localized("general.standard"),
			cell: (cell) => <YesNoTag value={cell.getValue()} />,
		}),
		columnHelper.accessor(createdAtFormatter, {
			id: "createdAt",
			header: localized("general_fields.created_at"),
			cell: (cell) => cell.getValue(),
		}),
		columnHelper.accessor(updatedAtFormatter, {
			id: "updatedAt",
			header: localized("general_fields.updated_at"),
			cell: (cell) => guardString(cell.getValue()),
		}),
		createRowActions<AcknowledgementDefinitionsListItem>((props) => (
			<RowActions
				{...props}
				isProjectContext={isProjectContext}
			/>
		)),
	];
}
